import { useAppSelector } from "../../hooks/StoreHooks";

export const useEmployeesUsers = () =>
  useAppSelector((state) => state.employees.users);

export const useCompanyEmployees = () =>
  useAppSelector((state) => state.employees.companyEmployees);

export const useEmployeeById = (employeeId: string) =>
  useAppSelector((state) =>
    state.employees.companyEmployees.find((emp) => emp.id === employeeId)
  );

export const useUserToEdit = () =>
  useAppSelector((state) => state.employees.userToEdit);

export const useEmployeeServiceModules = (employeeId: string) =>
  useAppSelector((state) => state.employees.employeeServiceModules[employeeId] ?? []);

export const useEmployeeActionModules = (employeeId: string) =>
  useAppSelector((state) => state.employees.employeeActionModules[employeeId] ?? []);

export const useEmployeeShopModules = (employeeId: string) =>
  useAppSelector((state) => state.employees.employeeShopModules[employeeId] ?? []);